const previewCards = [
  { icon: "ri-movie-2-line", label: "电影", value: "剧情 · 犯罪 · 科幻", tint: "bg-primary-500/15 text-primary-100" },
  { icon: "ri-tv-2-line", label: "电视剧", value: "连续剧 · 迷你剧", tint: "bg-accent-500/20 text-accent-100" },
  { icon: "ri-calendar-line", label: "最新电影", value: "按上映时间整理", tint: "bg-secondary-500/20 text-secondary-100" },
  { icon: "ri-fire-line", label: "欧美大片", value: "科幻 · 动作 · 系列", tint: "bg-primary-500/15 text-primary-100" },
];

const stats = [
  { value: "6", label: "内容方向" },
  { value: "20+", label: "精选条目" },
  { value: "4", label: "地区分类" },
];

export default function Hero() {
  return (
    <section id="top" className="relative w-full min-h-[680px] md:min-h-[760px] flex items-center overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20abstract%20film%20collage%20background%2C%20warm%20amber%20and%20deep%20charcoal%20tones%2C%20soft%20bokeh%20light%20flares%20and%20drifting%20dust%2C%20dramatic%20atmospheric%20mood%20with%20subtle%20texture%20grain%2C%20elegant%20editorial%20wide%20banner%20with%20empty%20space%20on%20the%20left%20for%20text%2C%20luxurious%20muted%20color%20palette&width=1920&height=1080&seq=sm-hero-main&orientation=landscape"
          alt="神马电影网首屏背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/55 to-black/30"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-black/30"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-28 md:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-center">
          <div className="lg:col-span-7 animate-fade-up">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/10 border border-white/20 text-background-100 text-xs tracking-wide backdrop-blur-sm">
              <i className="ri-clapperboard-line text-primary-300"></i>
              电影 · 电视剧 · 热播剧 一站式浏览
            </span>

            <h1 className="mt-6 text-3xl md:text-5xl font-bold leading-tight text-background-50">
              神马电影网，
              <br />
              发现值得看的电影与电视剧
            </h1>

            <p className="mt-5 max-w-xl text-sm md:text-base leading-8 text-background-100/90">
              这里把电影、电视剧、最新电影、热播剧、欧美大片与国产剧整理成清晰的内容类型，
              你可以在一个页面里了解各方向包含什么、有什么区别，并通过筛选与搜索缩小查询范围，
              更快找到想看的方向。
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <a
                href="#movies"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
              >
                <i className="ri-search-eye-line"></i>
                浏览最新电影
              </a>
              <a
                href="#overview"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-white/10 border border-white/25 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-white/20 transition-colors cursor-pointer backdrop-blur-sm"
              >
                <i className="ri-layout-grid-line"></i>
                查看内容类型
              </a>
            </div>

            <div className="mt-10 flex items-center gap-8 md:gap-10">
              {stats.map((stat) => (
                <div key={stat.label}>
                  <div className="text-2xl md:text-3xl font-bold text-primary-300">{stat.value}</div>
                  <div className="mt-1 text-xs text-background-200/80">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5 animate-fade-up">
            <div className="grid grid-cols-2 gap-3 md:gap-4">
              {previewCards.map((card) => (
                <a
                  key={card.label}
                  href="#overview"
                  className="group rounded-lg border border-white/15 bg-white/10 backdrop-blur-md p-4 md:p-5 hover:bg-white/20 transition-colors cursor-pointer"
                >
                  <span className={`w-10 h-10 rounded-md flex items-center justify-center ${card.tint}`}>
                    <i className={`${card.icon} text-xl`}></i>
                  </span>
                  <div className="mt-4 font-heading font-semibold text-background-50 text-base">{card.label}</div>
                  <div className="mt-1 text-xs text-background-200/80 leading-5">{card.value}</div>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}